import { Card, Typography, Checkbox, FormControlLabel, Box, Alert } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { workshopCardStyle } from "../../../../shared/styles/cardStyles";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setDraft } from "../../../../app/store/reservationSlice";
import filterContext from "../../../../app/providers/filter/filterContext";
import env from "../../../../app/config/envHelper";
import { useGetExtraServicesQuery } from "../../../../app/store/api/workshopApi";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export default function BaseServices({ category }) {
    const { i18n, t } = useTranslation();
    const draft = useSelector((state) => state.reservation.draft);
    const { state : filterState } = useContext(filterContext);
    const dispatch = useDispatch();
    const {data:services} = useGetExtraServicesQuery()
    const serviceFontStyleHeader = { fontWeight: 500, fontSize: "0.875rem" };
    const serviceFontStyleDescription = { opacity: 0.8, mt: 0.5, fontSize: "0.75rem" };

    useEffect(() => {
        // if draft services is an empty array, select services from filter
        if (!draft.services || draft.services.length === 0) {
            selectServicesFromFilter();
        }
    }, []);

    // Selecting services from filter
    const selectServicesFromFilter = () => {
        let selectedServices = [];
        filterState?.filter?.forEach(filterItem => {
            filterItem.services.forEach(service => {
                if (service.active) {
                    selectedServices.push(service);
                }
            });
        });
        dispatch(setDraft({ services: selectedServices })); // Add selected services to draft
    }

    const handleServiceClick = (service) => {
        let newServices;
        if (isServiceSelected(service)) {
            // Remove by id
            newServices = (draft.services || []).filter(s => s.id !== service.id);
        } else {
            // Add the whole service object if not already present (by id)
            newServices = [...(draft.services || []), service];
        }
        dispatch(setDraft({ services: newServices }));
    };

    // Check if a service is selected by id
    const isServiceSelected = (service) =>
        (draft.services || []).some(s => s.id === service.id);

    if (!draft.car) {
        return null; // Do not render if no car is selected
    }

    return (
        <Card sx={{ ...workshopCardStyle, marginTop: '20px', boxShadow: "none" }} className="workshop-base-services">
            <Typography
                variant="h5"
                component="div"
                sx={{ fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}
                className="baseServiceTitle"
            >
                { category === "extra" ? t("baseServices.extraServices") : t("baseServices.title") }
            </Typography>
            <Box className='base-service-checkboxes'>
                {services?.length > 0 &&
                    services?.map((service) => {
                        const isActive = isServiceSelected(service);
                        return (
                            <Alert
                                key={service.id}
                                icon={isActive ? <CheckCircleOutlineIcon /> : <RadioButtonUncheckedIcon />}
                                sx={{
                                    backgroundColor: isActive ? "rgb(214, 252, 255)" : "transparent",
                                    color: "#003C59",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "4px",
                                    marginBottom: "12px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                    backgroundColor: isActive ? "rgb(150, 229, 242)" : "#f5f5f5",
                                    },
                                    "& .MuiAlert-icon": {
                                    color: "#003C59",
                                    alignSelf: "center",
                                    },
                                    "& .MuiAlert-message": {
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    width: "100%",
                                    },
                                }}
                                onClick={() => handleServiceClick(service)}
                            >
                                <Typography variant='body1' sx={serviceFontStyleHeader}>
                                    {service.translations[i18n.language]?.name || service.translations.fi.name}
                                </Typography>
                                <Typography variant='body2' sx={serviceFontStyleDescription}>
                                    {service.translations[i18n.language]?.description || service.translations.fi.description}
                                </Typography>
                            </Alert>
                        );
                    })
                }
            </Box>
        </Card>
    );
}